import { render } from "./CategoriasProductos.vue?vue&type=template&id=24b8d3de"
import script from "./CategoriasProductos.js?vue&type=script&lang=js&external"
export * from "./CategoriasProductos.js?vue&type=script&lang=js&external"

import "./CategoriasProductos.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__